import { ElementType, Key } from 'react';

import Typography, { TypographyProps } from '@mui/material/Typography';

import { WithRef } from '../../../types';
import { Chip as DsChip, ChipProps as DsChipProps } from '../../chip';

export type InputChipProps<T extends ElementType = any> = {
  title: string;
  value?: string | string[] | number;
  delimiter?: string;
  key?: Key;
  titleProps?: TypographyProps<T, { component?: T }>;
  valueProps?: TypographyProps<T, { component?: T }>;
} & Omit<DsChipProps, 'children'>;

const InputChip = ({
  ref,
  title,
  value,
  delimiter = ':',
  titleProps,
  valueProps,
  ...rest
}: WithRef<HTMLDivElement, InputChipProps<'span'>>) => {
  if (value) {
    return (
      <DsChip {...rest} ref={ref}>
        <Typography data-testid="chip-title" color="inherit" {...titleProps}>
          {title}
          {delimiter}{' '}
        </Typography>
        <Typography
          className="DsChip-value"
          data-testid="chip-value"
          color="inherit"
          {...valueProps}
        >
          {value.toString().replace('\n', ', ')}
        </Typography>
      </DsChip>
    );
  }
  return (
    <DsChip {...rest} ref={ref}>
      {title}
    </DsChip>
  );
};

InputChip.displayName = 'InputChip';

export default InputChip;
